module.exports = __webpack_public_path__ + "6a987b43f6dff96c67ab55fe93bd42c0.jpg";